{
  "current": {
    "reviewVersion": "analects-concept-editorial-20261007-v2",
    "catalogContentSha256": "513b3f7dd0fd4347a82ed4bb6f0ff69d9453245146ea53f973637cb1e407a550"
  },
  "historical": {
    "version": "analects-topic-v1",
    "sourceRepository": "ieduer/lunyu-battle",
    "sourceCommit": "397585912644d1ad76b6e5de8ce4e06ad8e16cce",
    "inputs": {
      "src/workbench/conceptCatalog.ts": "bb8cfc96c2cbb56a745c880a47400c174d470a270374bc683957e43a0700a4c4",
      "src/workbench/conceptIndex.ts": "c9bf7a8d831aadec1beeb3c8b283917581cbf142c5011930e48b3dbbd867deec"
    },
    "reviewSource": {
      "version": "analects-concept-editorial-20261006-v1",
      "repository": "ieduer/lunyu",
      "commit": "69674ff161ff2272ab97f3aa3fda97a8c10a8fb4",
      "sha256": "8c9ebc18d6c6f0c156cad89aaab89f6a413cab0f9b2fa2fa7b65ac2b0d4400b1",
      "method": "Source-grounded editorial reading of each quoted chapter and applicable Yang notes; separate from inferred game tags",
      "completeThematicRoute": false,
      "changesHistoricalGrades": false
    },
    "glyphPairs": "節节濟济優优寬宽猶犹禮礼學学習习義义為为愛爱樂乐詩诗書书賢贤聖圣過过恥耻憂忧貧贫賤贱貴贵問问見见聞闻誨诲啟启憤愤類类溫温舉举貫贯隱隐從从處处質质喪丧儉俭讓让鄉乡時时無无於于與与謹谨達达遠远邇迩親亲強强剛刚惡恶順顺殺杀身身觀观興兴眾众復复諸诸務务則则說说讒谗諂谄訥讷謀谋齊齐異异兌兑誠诚勇勇窮穷篤笃執执遜逊敬敬祿禄饑饥餓饿飲饮飯饭疏疏繪绘素素聽听辭辞祀祀祭祭諒谅誼谊藝艺遊游體体衛卫論论語语許许隨随進进退退悅悦誦诵駟驷馬马鳥鸟獸兽樊樊遲迟顏颜淵渊貢贡閔闵騫骞張张參参長长魯鲁堯尧舜舜湯汤羣群",
    "concepts": [
      {
        "id": "ren",
        "label": "仁",
        "group": "德行與修身",
        "terms": [
          "仁"
        ],
        "note": "列出所有含「仁」的原文；指仁德、仁者或地名等仍須看上下文。",
        "related": [
          "shu",
          "li",
          "airen",
          "keji"
        ]
      },
      {
        "id": "li",
        "label": "禮",
        "group": "禮樂與文質",
        "terms": [
          "禮"
        ],
        "note": "禮／礼合查，儀節、制度與內在敬意須連同上下文閱讀。",
        "related": [
          "ren",
          "jing",
          "yue"
        ]
      },
      {
        "id": "xue",
        "label": "學",
        "group": "學習與教育",
        "terms": [
          "學"
        ],
        "related": [
          "xi",
          "si",
          "haoxue",
          "jiaoxue"
        ]
      },
      {
        "id": "junzi",
        "label": "君子",
        "group": "人格與人物",
        "terms": [
          "君子"
        ],
        "note": "不同章句中的德行標準與身分稱謂，須據原文辨別。",
        "related": [
          "xiaoren",
          "shi",
          "yili"
        ]
      },
      {
        "id": "xiao",
        "label": "孝",
        "group": "親友與相處",
        "terms": [
          "孝"
        ],
        "related": [
          "ti",
          "jing",
          "fumu"
        ]
      },
      {
        "id": "shu",
        "label": "忠恕",
        "group": "親友與相處",
        "terms": [
          "忠恕"
        ],
        "note": "直接命中只查連寫的「忠恕」；忠、恕及推己及人的相關章另有獨立入口。",
        "related": [
          "zhong",
          "forbearance",
          "jisuobuyu"
        ]
      },
      {
        "id": "xin",
        "label": "信",
        "group": "德行與修身",
        "terms": [
          "信"
        ],
        "note": "既可能指守信／信任，也可能意為「確實」（如14.13「信乎」）；字詞命中不等於同一思想。",
        "related": [
          "zhong",
          "yi",
          "pengyou"
        ]
      },
      {
        "id": "yili",
        "label": "義利",
        "group": "德行與修身",
        "terms": [
          "義利"
        ],
        "note": "「義利」是比較主題；原文往往分說義、利。連寫命中可能為零，請另讀下方已核對關聯或分查兩字。",
        "related": [
          "yi",
          "li-benefit",
          "fugui",
          "pin"
        ]
      },
      {
        "id": "zheng",
        "label": "為政",
        "group": "政治與秩序",
        "terms": [
          "為政"
        ],
        "related": [
          "de",
          "min",
          "zhengming",
          "xing"
        ]
      },
      {
        "id": "zhengming",
        "label": "正名",
        "group": "政治與秩序",
        "terms": [
          "正名"
        ],
        "related": [
          "ming-name",
          "yan",
          "li"
        ]
      },
      {
        "id": "zhiren",
        "label": "知人",
        "group": "人格與人物",
        "terms": [
          "知人"
        ],
        "note": "「知」在知人、知道、智慧等處用法不同；不把全部「知」自動列入智慧主題。",
        "related": [
          "zhi",
          "xian",
          "guan"
        ]
      },
      {
        "id": "zhongyong",
        "label": "中庸",
        "group": "德行與修身",
        "terms": [
          "中庸"
        ],
        "related": [
          "he",
          "guoyoubuji",
          "xiangyuan"
        ]
      },
      {
        "id": "tianming",
        "label": "天命",
        "group": "天命與鬼神",
        "terms": [
          "天命"
        ],
        "note": "天命、命令、性命並非同義；「命」另列全量字詞入口。",
        "related": [
          "tian",
          "ming",
          "guishen"
        ]
      },
      {
        "id": "wenzhi",
        "label": "文質",
        "group": "禮樂與文質",
        "terms": [
          "文質"
        ],
        "related": [
          "wen",
          "zhi-quality",
          "binbin"
        ]
      },
      {
        "id": "shijiao",
        "label": "詩教",
        "group": "禮樂與文質",
        "terms": [
          "詩教"
        ],
        "note": "主題名稱不必是原文連寫詞；詩的字詞命中與已核對教學關聯分開。",
        "related": [
          "shi-poetry",
          "yue",
          "jiaoxue"
        ]
      },
      {
        "id": "chushi",
        "label": "出處",
        "group": "行道與進退",
        "terms": [
          "出處"
        ],
        "note": "出仕或退隱是此處的主題義；不把所有「出」「處」合算為主題證據。",
        "related": [
          "shi-office",
          "yin",
          "dao",
          "bangyoudao"
        ]
      },
      {
        "id": "jiaoxue",
        "label": "教學",
        "group": "學習與教育",
        "terms": [
          "教學"
        ],
        "note": "以原文具體施教方式核對主題；教／學字詞命中可分別查找。",
        "related": [
          "jiao",
          "hui",
          "youjiaowulei",
          "juyiyu"
        ]
      },
      {
        "id": "yi",
        "label": "義",
        "group": "德行與修身",
        "terms": [
          "義"
        ]
      },
      {
        "id": "li-benefit",
        "label": "利",
        "group": "德行與修身",
        "terms": [
          "利"
        ]
      },
      {
        "id": "de",
        "label": "德",
        "group": "德行與修身",
        "terms": [
          "德"
        ]
      },
      {
        "id": "zhong",
        "label": "忠",
        "group": "德行與修身",
        "terms": [
          "忠"
        ]
      },
      {
        "id": "forbearance",
        "label": "恕",
        "group": "親友與相處",
        "terms": [
          "恕"
        ]
      },
      {
        "id": "yong",
        "label": "勇",
        "group": "德行與修身",
        "terms": [
          "勇"
        ]
      },
      {
        "id": "jing",
        "label": "敬",
        "group": "德行與修身",
        "terms": [
          "敬"
        ]
      },
      {
        "id": "cheng",
        "label": "誠",
        "group": "德行與修身",
        "terms": [
          "誠"
        ]
      },
      {
        "id": "gong",
        "label": "恭",
        "group": "德行與修身",
        "terms": [
          "恭"
        ]
      },
      {
        "id": "kuan",
        "label": "寬",
        "group": "德行與修身",
        "terms": [
          "寬"
        ]
      },
      {
        "id": "min-diligence",
        "label": "敏",
        "group": "德行與修身",
        "terms": [
          "敏"
        ]
      },
      {
        "id": "hui-kindness",
        "label": "惠",
        "group": "德行與修身",
        "terms": [
          "惠"
        ]
      },
      {
        "id": "zhi-upright",
        "label": "直",
        "group": "德行與修身",
        "terms": [
          "直"
        ]
      },
      {
        "id": "chi",
        "label": "恥",
        "group": "德行與修身",
        "terms": [
          "恥"
        ]
      },
      {
        "id": "guo",
        "label": "過",
        "group": "德行與修身",
        "terms": [
          "過"
        ],
        "note": "過可指過失，也可指經過或過度，全部命中保留。"
      },
      {
        "id": "gai",
        "label": "改",
        "group": "德行與修身",
        "terms": [
          "改"
        ]
      },
      {
        "id": "sheng",
        "label": "省",
        "group": "德行與修身",
        "terms": [
          "省"
        ]
      },
      {
        "id": "keji",
        "label": "克己",
        "group": "德行與修身",
        "terms": [
          "克己"
        ]
      },
      {
        "id": "sanxing",
        "label": "三省",
        "group": "德行與修身",
        "terms": [
          "三省"
        ]
      },
      {
        "id": "he",
        "label": "和",
        "group": "德行與修身",
        "terms": [
          "和"
        ]
      },
      {
        "id": "guoyoubuji",
        "label": "過猶不及",
        "group": "德行與修身",
        "terms": [
          "過猶不及"
        ]
      },
      {
        "id": "hebutong",
        "label": "和而不同",
        "group": "親友與相處",
        "terms": [
          "和而不同"
        ]
      },
      {
        "id": "xiangyuan",
        "label": "鄉愿",
        "group": "德行與修身",
        "terms": [
          "鄉愿"
        ],
        "note": "愿與願不可任意互換；此處保留底本「鄉愿／乡愿」。"
      },
      {
        "id": "xi",
        "label": "習",
        "group": "學習與教育",
        "terms": [
          "習"
        ]
      },
      {
        "id": "si",
        "label": "思",
        "group": "學習與教育",
        "terms": [
          "思"
        ]
      },
      {
        "id": "zhi",
        "label": "知",
        "group": "學習與教育",
        "terms": [
          "知"
        ],
        "note": "本入口不把「知」一律改為智；請依註釋區分知道、識人與智慧。",
        "related": [
          "wisdom",
          "zhiren"
        ]
      },
      {
        "id": "wisdom",
        "label": "智",
        "group": "德行與修身",
        "terms": [
          "智"
        ],
        "note": "「智」與通作智的「知」分開：直接查智，主題相關列明已核對的知字章句。",
        "related": [
          "zhi",
          "ren",
          "yong"
        ]
      },
      {
        "id": "wen-ask",
        "label": "問",
        "group": "學習與教育",
        "terms": [
          "問"
        ]
      },
      {
        "id": "wen-hear",
        "label": "聞",
        "group": "學習與教育",
        "terms": [
          "聞"
        ]
      },
      {
        "id": "haoxue",
        "label": "好學",
        "group": "學習與教育",
        "terms": [
          "好學"
        ]
      },
      {
        "id": "wengu",
        "label": "溫故",
        "group": "學習與教育",
        "terms": [
          "溫故"
        ]
      },
      {
        "id": "zhixin",
        "label": "知新",
        "group": "學習與教育",
        "terms": [
          "知新"
        ]
      },
      {
        "id": "jiao",
        "label": "教",
        "group": "學習與教育",
        "terms": [
          "教"
        ]
      },
      {
        "id": "hui",
        "label": "誨",
        "group": "學習與教育",
        "terms": [
          "誨"
        ]
      },
      {
        "id": "qi",
        "label": "啟",
        "group": "學習與教育",
        "terms": [
          "啟"
        ]
      },
      {
        "id": "youjiaowulei",
        "label": "有教無類",
        "group": "學習與教育",
        "terms": [
          "有教無類"
        ]
      },
      {
        "id": "juyiyu",
        "label": "舉一隅",
        "group": "學習與教育",
        "terms": [
          "舉一隅"
        ]
      },
      {
        "id": "buyichiwen",
        "label": "不恥下問",
        "group": "學習與教育",
        "terms": [
          "不恥下問"
        ]
      },
      {
        "id": "xuezhizhi",
        "label": "學而知之",
        "group": "學習與教育",
        "terms": [
          "學而知之"
        ]
      },
      {
        "id": "xueersi",
        "label": "學而不思",
        "group": "學習與教育",
        "terms": [
          "學而不思"
        ]
      },
      {
        "id": "xueroushi",
        "label": "學而優則仕",
        "group": "學習與教育",
        "terms": [
          "學而優則仕"
        ]
      },
      {
        "id": "ti",
        "label": "悌",
        "group": "親友與相處",
        "terms": [
          "悌"
        ],
        "note": "悌與弟不全量互換；1.2的孝弟另列有依据的思想關聯。",
        "related": [
          "di",
          "xiao"
        ]
      },
      {
        "id": "di",
        "label": "弟",
        "group": "親友與相處",
        "terms": [
          "弟"
        ],
        "note": "弟子、兄弟與通悌的弟須分辨；這裡保留所有字詞命中。"
      },
      {
        "id": "fumu",
        "label": "父母",
        "group": "親友與相處",
        "terms": [
          "父母"
        ]
      },
      {
        "id": "xiongdi",
        "label": "兄弟",
        "group": "親友與相處",
        "terms": [
          "兄弟"
        ]
      },
      {
        "id": "pengyou",
        "label": "朋友",
        "group": "親友與相處",
        "terms": [
          "朋友"
        ]
      },
      {
        "id": "you",
        "label": "友",
        "group": "親友與相處",
        "terms": [
          "友"
        ]
      },
      {
        "id": "ai",
        "label": "愛",
        "group": "親友與相處",
        "terms": [
          "愛"
        ]
      },
      {
        "id": "airen",
        "label": "愛人",
        "group": "親友與相處",
        "terms": [
          "愛人"
        ]
      },
      {
        "id": "jisuobuyu",
        "label": "己所不欲",
        "group": "親友與相處",
        "terms": [
          "己所不欲"
        ]
      },
      {
        "id": "wushiyuren",
        "label": "勿施於人",
        "group": "親友與相處",
        "terms": [
          "勿施於人"
        ]
      },
      {
        "id": "jiyuli",
        "label": "己欲立而立人",
        "group": "親友與相處",
        "terms": [
          "己欲立而立人"
        ]
      },
      {
        "id": "jinqupi",
        "label": "能近取譬",
        "group": "親友與相處",
        "terms": [
          "能近取譬"
        ]
      },
      {
        "id": "zheng-politics",
        "label": "政",
        "group": "政治與秩序",
        "terms": [
          "政"
        ]
      },
      {
        "id": "min",
        "label": "民",
        "group": "政治與秩序",
        "terms": [
          "民"
        ]
      },
      {
        "id": "xing",
        "label": "刑",
        "group": "政治與秩序",
        "terms": [
          "刑"
        ]
      },
      {
        "id": "jun",
        "label": "君",
        "group": "政治與秩序",
        "terms": [
          "君"
        ]
      },
      {
        "id": "chen",
        "label": "臣",
        "group": "政治與秩序",
        "terms": [
          "臣"
        ]
      },
      {
        "id": "bang",
        "label": "邦",
        "group": "政治與秩序",
        "terms": [
          "邦"
        ]
      },
      {
        "id": "ming-name",
        "label": "名",
        "group": "政治與秩序",
        "terms": [
          "名"
        ]
      },
      {
        "id": "zheng-upright",
        "label": "正",
        "group": "政治與秩序",
        "terms": [
          "正"
        ]
      },
      {
        "id": "minxin",
        "label": "民信",
        "group": "政治與秩序",
        "terms": [
          "民信"
        ]
      },
      {
        "id": "zhengyide",
        "label": "為政以德",
        "group": "政治與秩序",
        "terms": [
          "為政以德"
        ]
      },
      {
        "id": "yan",
        "label": "言",
        "group": "政治與秩序",
        "terms": [
          "言"
        ]
      },
      {
        "id": "xing-act",
        "label": "行",
        "group": "行道與進退",
        "terms": [
          "行"
        ],
        "note": "讀音與意思須依章句判断，不把行走與德行混作同義。"
      },
      {
        "id": "dao",
        "label": "道",
        "group": "行道與進退",
        "terms": [
          "道"
        ],
        "note": "道路、學說、方法、政治有道及引導的道不同；完整命中不作同義判定。"
      },
      {
        "id": "shi-office",
        "label": "仕",
        "group": "行道與進退",
        "terms": [
          "仕"
        ]
      },
      {
        "id": "yin",
        "label": "隱",
        "group": "行道與進退",
        "terms": [
          "隱"
        ]
      },
      {
        "id": "bangyoudao",
        "label": "邦有道",
        "group": "行道與進退",
        "terms": [
          "邦有道"
        ]
      },
      {
        "id": "bangwudao",
        "label": "邦無道",
        "group": "行道與進退",
        "terms": [
          "邦無道"
        ]
      },
      {
        "id": "fugui",
        "label": "富貴",
        "group": "行道與進退",
        "terms": [
          "富貴"
        ]
      },
      {
        "id": "fu",
        "label": "富",
        "group": "行道與進退",
        "terms": [
          "富"
        ]
      },
      {
        "id": "pin",
        "label": "貧",
        "group": "行道與進退",
        "terms": [
          "貧"
        ]
      },
      {
        "id": "jian",
        "label": "賤",
        "group": "行道與進退",
        "terms": [
          "賤"
        ]
      },
      {
        "id": "buyi",
        "label": "不義",
        "group": "行道與進退",
        "terms": [
          "不義"
        ]
      },
      {
        "id": "zhizhebuwei",
        "label": "知其不可而為之",
        "group": "行道與進退",
        "terms": [
          "知其不可而為之"
        ]
      },
      {
        "id": "tian",
        "label": "天",
        "group": "天命與鬼神",
        "terms": [
          "天"
        ]
      },
      {
        "id": "ming",
        "label": "命",
        "group": "天命與鬼神",
        "terms": [
          "命"
        ]
      },
      {
        "id": "guishen",
        "label": "鬼神",
        "group": "天命與鬼神",
        "terms": [
          "鬼神"
        ]
      },
      {
        "id": "si-death",
        "label": "死",
        "group": "天命與鬼神",
        "terms": [
          "死"
        ]
      },
      {
        "id": "sheng-life",
        "label": "生",
        "group": "天命與鬼神",
        "terms": [
          "生"
        ]
      },
      {
        "id": "ji",
        "label": "祭",
        "group": "禮樂與文質",
        "terms": [
          "祭"
        ]
      },
      {
        "id": "sang",
        "label": "喪",
        "group": "禮樂與文質",
        "terms": [
          "喪"
        ]
      },
      {
        "id": "jian-frugal",
        "label": "儉",
        "group": "禮樂與文質",
        "terms": [
          "儉"
        ]
      },
      {
        "id": "rang",
        "label": "讓",
        "group": "禮樂與文質",
        "terms": [
          "讓"
        ]
      },
      {
        "id": "wen",
        "label": "文",
        "group": "禮樂與文質",
        "terms": [
          "文"
        ]
      },
      {
        "id": "zhi-quality",
        "label": "質",
        "group": "禮樂與文質",
        "terms": [
          "質"
        ]
      },
      {
        "id": "binbin",
        "label": "彬彬",
        "group": "禮樂與文質",
        "terms": [
          "彬彬"
        ]
      },
      {
        "id": "shi-poetry",
        "label": "詩",
        "group": "禮樂與文質",
        "terms": [
          "詩"
        ]
      },
      {
        "id": "yue",
        "label": "樂",
        "group": "禮樂與文質",
        "terms": [
          "樂"
        ],
        "note": "音樂、喜樂、樂於等用法一併命中；已核對主題用法另附理由，不能全當作樂教。",
        "related": [
          "shijiao",
          "li"
        ]
      },
      {
        "id": "renle",
        "label": "仁者樂山",
        "group": "天命與鬼神",
        "terms": [
          "仁者樂山"
        ]
      },
      {
        "id": "zhile",
        "label": "知者樂水",
        "group": "天命與鬼神",
        "terms": [
          "知者樂水"
        ]
      },
      {
        "id": "xiaoren",
        "label": "小人",
        "group": "人格與人物",
        "terms": [
          "小人"
        ]
      },
      {
        "id": "shi",
        "label": "士",
        "group": "人格與人物",
        "terms": [
          "士"
        ]
      },
      {
        "id": "xian",
        "label": "賢",
        "group": "人格與人物",
        "terms": [
          "賢"
        ]
      },
      {
        "id": "sheng-sage",
        "label": "聖",
        "group": "人格與人物",
        "terms": [
          "聖"
        ]
      },
      {
        "id": "xing-nature",
        "label": "性",
        "group": "學習與教育",
        "terms": [
          "性"
        ],
        "note": "性與習相對的討論，須保留其章句語境。",
        "related": [
          "xi",
          "xue"
        ]
      },
      {
        "id": "zhi-aspiration",
        "label": "志",
        "group": "德行與修身",
        "terms": [
          "志"
        ]
      },
      {
        "id": "yu",
        "label": "欲",
        "group": "德行與修身",
        "terms": [
          "欲"
        ]
      },
      {
        "id": "yuan",
        "label": "怨",
        "group": "親友與相處",
        "terms": [
          "怨"
        ]
      },
      {
        "id": "jin",
        "label": "謹",
        "group": "德行與修身",
        "terms": [
          "謹"
        ]
      },
      {
        "id": "shen",
        "label": "慎",
        "group": "德行與修身",
        "terms": [
          "慎"
        ]
      },
      {
        "id": "jie",
        "label": "節",
        "group": "禮樂與文質",
        "terms": [
          "節"
        ]
      },
      {
        "id": "xiuyi",
        "label": "修己",
        "group": "德行與修身",
        "terms": [
          "修己"
        ]
      },
      {
        "id": "anren",
        "label": "安人",
        "group": "政治與秩序",
        "terms": [
          "安人"
        ]
      },
      {
        "id": "anbaixing",
        "label": "安百姓",
        "group": "政治與秩序",
        "terms": [
          "安百姓"
        ]
      },
      {
        "id": "boshi",
        "label": "博施",
        "group": "政治與秩序",
        "terms": [
          "博施"
        ]
      },
      {
        "id": "jizhong",
        "label": "濟眾",
        "group": "政治與秩序",
        "terms": [
          "濟眾"
        ]
      },
      {
        "id": "boxue",
        "label": "博學",
        "group": "學習與教育",
        "terms": [
          "博學"
        ]
      },
      {
        "id": "duzhi",
        "label": "篤志",
        "group": "學習與教育",
        "terms": [
          "篤志"
        ]
      },
      {
        "id": "qiewen",
        "label": "切問",
        "group": "學習與教育",
        "terms": [
          "切問"
        ]
      },
      {
        "id": "jinsi",
        "label": "近思",
        "group": "學習與教育",
        "terms": [
          "近思"
        ]
      },
      {
        "id": "qiaoyanlingse",
        "label": "巧言令色",
        "group": "人格與人物",
        "terms": [
          "巧言令色"
        ]
      },
      {
        "id": "zhongxin",
        "label": "忠信",
        "group": "德行與修身",
        "terms": [
          "忠信"
        ]
      },
      {
        "id": "sibi",
        "label": "毋意",
        "group": "德行與修身",
        "terms": [
          "毋意"
        ]
      },
      {
        "id": "renren",
        "label": "仁人",
        "group": "人格與人物",
        "terms": [
          "仁人"
        ]
      },
      {
        "id": "shanren",
        "label": "善人",
        "group": "人格與人物",
        "terms": [
          "善人"
        ]
      },
      {
        "id": "chengren",
        "label": "成人",
        "group": "人格與人物",
        "terms": [
          "成人"
        ]
      },
      {
        "id": "guan",
        "label": "觀",
        "group": "人格與人物",
        "terms": [
          "觀"
        ]
      }
    ],
    "relations": [
      {
        "coordinate": "1.1",
        "quote": "学而时习之",
        "concepts": [
          "xue",
          "xi",
          "junzi"
        ],
        "reason": "學、習與人不知而不愠同章呈現；後一句將待人態度連到君子。"
      },
      {
        "coordinate": "1.2",
        "quote": "孝弟也者，其为仁之本",
        "concepts": [
          "xiao",
          "ti",
          "ren",
          "junzi"
        ],
        "reason": "有子把孝弟稱為為仁之本；此處弟据本章注釋讀作悌，不據此改寫全書所有弟字。"
      },
      {
        "coordinate": "1.4",
        "quote": "吾日三省吾身",
        "concepts": [
          "sanxing",
          "sheng",
          "zhong",
          "xin",
          "xue",
          "xi"
        ],
        "reason": "曾子以替人盡心、交友守信與溫習所傳，作為每日反省的三項內容。"
      },
      {
        "coordinate": "1.6",
        "quote": "弟子入则孝",
        "concepts": [
          "xiao",
          "ti",
          "xin",
          "ren",
          "xue"
        ],
        "reason": "孝悌、謹信、愛眾親仁在前，行有餘力學文在後，呈現躬行與學文關係。"
      },
      {
        "coordinate": "1.8",
        "quote": "过，则勿惮改",
        "concepts": [
          "junzi",
          "zhong",
          "xin",
          "guo",
          "gai"
        ],
        "reason": "莊重、忠信與改過共同構成此章君子自修的要求。"
      },
      {
        "coordinate": "1.12",
        "quote": "礼之用，和为贵",
        "concepts": [
          "li",
          "he",
          "zhongyong"
        ],
        "reason": "和須有禮的節制；本章可與中庸比較，不能把和簡化為無條件附和。"
      },
      {
        "coordinate": "1.13",
        "quote": "信近于义",
        "concepts": [
          "xin",
          "yi",
          "li",
          "gong"
        ],
        "reason": "守約先合義，恭敬合禮；信與恭都帶有規範條件。"
      },
      {
        "coordinate": "2.3",
        "quote": "道之以德，齐之以礼",
        "concepts": [
          "zheng",
          "de",
          "li",
          "xing",
          "chi",
          "dao"
        ],
        "reason": "政刑與德禮兩種治理效果被直接比較；此章道字作引導理解。"
      },
      {
        "coordinate": "2.4",
        "quote": "五十而知天命",
        "concepts": [
          "tianming",
          "xue",
          "li"
        ],
        "reason": "自述從志學至知命、從心不踰矩的生命歷程，可比較學習與規範的內化。"
      },
      {
        "coordinate": "2.7",
        "quote": "不敬，何以别乎",
        "concepts": [
          "xiao",
          "jing"
        ],
        "reason": "以不敬則無別辨明：供養不足以單獨構成孝。"
      },
      {
        "coordinate": "2.11",
        "quote": "温故而知新",
        "concepts": [
          "xue",
          "jiaoxue",
          "wengu",
          "zhixin"
        ],
        "reason": "溫故須能知新，並以此說明可以為師的條件。"
      },
      {
        "coordinate": "2.15",
        "quote": "学而不思则罔",
        "concepts": [
          "xue",
          "si",
          "xueersi"
        ],
        "reason": "章句成對指出只學不思與只思不學的問題。"
      },
      {
        "coordinate": "2.17",
        "quote": "知之为知之，不知为不知，是知也",
        "concepts": [
          "zhi",
          "wisdom",
          "jiaoxue"
        ],
        "reason": "據楊注，末一知指智慧，前面的知指知道；同章不能用全字替換混淆詞義。"
      },
      {
        "coordinate": "3.3",
        "quote": "人而不仁，如礼何",
        "concepts": [
          "ren",
          "li",
          "yue"
        ],
        "reason": "禮與樂並列，以仁作為有意義地對待二者的內在條件；此處樂指音樂。"
      },
      {
        "coordinate": "3.8",
        "quote": "绘事后素",
        "concepts": [
          "wenzhi",
          "shijiao",
          "jiaoxue",
          "li"
        ],
        "reason": "由繪畫底子引出禮後的追問；子夏舉一反三反過來啟發老師。這是文質的比較材料，非原文明說文質。"
      },
      {
        "coordinate": "4.5",
        "quote": "不以其道得之，不处也",
        "concepts": [
          "yili",
          "ren",
          "junzi",
          "fugui",
          "pin"
        ],
        "reason": "富貴的取捨以得之是否合道為條件，並要求君子顛沛中不違仁。"
      },
      {
        "coordinate": "4.15",
        "quote": "夫子之道，忠恕而已矣",
        "concepts": [
          "shu",
          "zhong",
          "forbearance",
          "dao"
        ],
        "reason": "曾子用忠恕解釋一以貫之；須保留孔子與曾子發言層次。"
      },
      {
        "coordinate": "4.16",
        "quote": "君子喻于义，小人喻于利",
        "concepts": [
          "yili",
          "yi",
          "li-benefit",
          "junzi",
          "xiaoren"
        ],
        "reason": "以義與利對舉辨君子小人的關注，兩字分開出現，不能只檢索義利連寫。"
      },
      {
        "coordinate": "5.12",
        "quote": "我不欲人之加诸我也",
        "concepts": [
          "forbearance",
          "shu"
        ],
        "reason": "子貢提出不欲受施亦不施人的志向，孔子指出實行的難度，可與15.24對讀。"
      },
      {
        "coordinate": "6.18",
        "quote": "文质彬彬",
        "concepts": [
          "wenzhi",
          "wen",
          "zhi-quality",
          "binbin",
          "junzi"
        ],
        "reason": "以野、史兩偏說明文與質須相配，最後落到君子的標準。"
      },
      {
        "coordinate": "6.22",
        "quote": "敬鬼神而远之",
        "concepts": [
          "wisdom",
          "zhi",
          "ren",
          "tianming",
          "guishen"
        ],
        "reason": "答問知時強調務民之義與敬而遠之；答仁又說先難後獲，兩段問答不可混成一句。"
      },
      {
        "coordinate": "6.23",
        "quote": "知者乐水，仁者乐山",
        "concepts": [
          "wisdom",
          "ren",
          "yue",
          "renle",
          "zhile"
        ],
        "reason": "以山水動靜比況知者與仁者；此處樂水樂山作喜好，末句知者樂指快樂，不是音樂。"
      },
      {
        "coordinate": "6.29",
        "quote": "中庸之为德也",
        "concepts": [
          "zhongyong",
          "de"
        ],
        "reason": "此章直接稱中庸為至德，並慨嘆其長期稀少。"
      },
      {
        "coordinate": "6.30",
        "quote": "己欲立而立人",
        "concepts": [
          "ren",
          "shu",
          "forbearance",
          "jiyuli",
          "jinqupi"
        ],
        "reason": "从博施濟眾之問轉到由己及人的實行方法，能近取譬是仁之方。"
      },
      {
        "coordinate": "7.8",
        "quote": "举一隅不以三隅反",
        "concepts": [
          "jiaoxue",
          "qi",
          "juyiyu"
        ],
        "reason": "啟發以學生已用力求解為條件，並要求由一隅推及三隅。"
      },
      {
        "coordinate": "11.16",
        "quote": "过犹不及",
        "concepts": [
          "zhongyong",
          "guoyoubuji"
        ],
        "reason": "師過與商不及被並列指出；子貢追問後，孔子明說過與不及同樣有偏。"
      },
      {
        "coordinate": "11.22",
        "quote": "求也退，故进之；由也兼人，故退之",
        "concepts": [
          "jiaoxue",
          "wen-hear",
          "xing-act"
        ],
        "reason": "同問聞斯行諸，冉求與仲由得到不同回答；孔子明說根據二人的退與勇進分別引導。"
      },
      {
        "coordinate": "12.1",
        "quote": "克己复礼为仁",
        "concepts": [
          "ren",
          "li",
          "keji"
        ],
        "reason": "答顏淵以克己復禮界定實行仁的路徑，再具體落到視聽言動。"
      },
      {
        "coordinate": "12.2",
        "quote": "己所不欲，勿施于人",
        "concepts": [
          "ren",
          "shu",
          "forbearance",
          "jing",
          "jisuobuyu",
          "wushiyuren"
        ],
        "reason": "答仲弓問仁，把待人敬慎與不強施所不欲並列；本章沒有恕字也可據內容關聯。"
      },
      {
        "coordinate": "12.7",
        "quote": "民无信不立",
        "concepts": [
          "xin",
          "zheng",
          "minxin",
          "min"
        ],
        "reason": "子貢問政的三次取捨把民信置於最後；這裡信偏重人民對治理者的信任。"
      },
      {
        "coordinate": "12.17",
        "quote": "政者，正也",
        "concepts": [
          "zheng",
          "zheng-upright",
          "de"
        ],
        "reason": "以治理者率先端正回答政治問題；正己與為政直接相連。"
      },
      {
        "coordinate": "12.22",
        "quote": "樊迟问仁。子曰：“爱人。”问知。子曰：“知人。”",
        "concepts": [
          "ren",
          "airen",
          "zhiren",
          "wisdom",
          "zhi"
        ],
        "reason": "仁答愛人，知答知人，後以舉直錯枉及選賢說明，保留二者区别與相聯。"
      },
      {
        "coordinate": "13.3",
        "quote": "必也正名乎",
        "concepts": [
          "zhengming",
          "zheng",
          "li",
          "yan",
          "ming-name"
        ],
        "reason": "正名連到言順、事成、禮樂與刑罰，須閱讀整個治理推論，不能只擷取口號。"
      },
      {
        "coordinate": "13.5",
        "quote": "诵《诗》三百",
        "concepts": [
          "shijiao",
          "shi-poetry",
          "xue",
          "zheng"
        ],
        "reason": "以行政與外交不能運用所學質疑徒多的誦詩，構成知行遷移的反省。"
      },
      {
        "coordinate": "13.23",
        "quote": "君子和而不同",
        "concepts": [
          "zhongyong",
          "he",
          "hebutong",
          "junzi",
          "xiaoren"
        ],
        "reason": "君子和與小人同構成對照；作為中庸比較讀物，不能將二詞宣稱完全同義。"
      },
      {
        "coordinate": "14.13",
        "quote": "信乎，夫子不言",
        "concepts": [
          "xin",
          "yi",
          "yan"
        ],
        "reason": "此處信乎是詢問是否確實，不是德目守信；後文義然後取另屬取捨條件，特保留此消歧反例。"
      },
      {
        "coordinate": "14.38",
        "quote": "知其不可而为之",
        "concepts": [
          "chushi",
          "zhizhebuwei"
        ],
        "reason": "晨門者評孔子之行，可與隱者的選擇比較；評語的發言者不是孔子。"
      },
      {
        "coordinate": "15.9",
        "quote": "有杀身以成仁",
        "concepts": [
          "ren",
          "yong",
          "renren",
          "shi"
        ],
        "reason": "志士仁人以仁為生死取捨的條件，可與一般求勇相區分。"
      },
      {
        "coordinate": "15.24",
        "quote": "其恕乎",
        "concepts": [
          "shu",
          "forbearance",
          "jisuobuyu",
          "wushiyuren"
        ],
        "reason": "孔子以恕回答終身可行的一言，再以己所不欲勿施於人具體解說。"
      },
      {
        "coordinate": "15.39",
        "quote": "有教无类",
        "concepts": [
          "jiaoxue",
          "jiao",
          "youjiaowulei"
        ],
        "reason": "本章直接說明施教不以類別設限；不額外假造同章中不存在的教學方法。"
      },
      {
        "coordinate": "16.9",
        "quote": "学而知之者次也",
        "concepts": [
          "xue",
          "zhi",
          "xuezhizhi"
        ],
        "reason": "區分生知、學知、困而學及困而不學；字面排列不等於學生的固定能力等級。"
      },
      {
        "coordinate": "17.9",
        "quote": "诗，可以兴，可以观，可以羣，可以怨",
        "concepts": [
          "shijiao",
          "shi-poetry",
          "xue",
          "guan"
        ],
        "reason": "孔子鼓勵學詩，列興觀群怨與事父事君、辨名物等用途。羣／群是本索引核可字形對應。"
      },
      {
        "coordinate": "17.13",
        "quote": "乡愿，德之贼也",
        "concepts": [
          "xiangyuan",
          "zhongyong",
          "de"
        ],
        "reason": "孔子明斥鄉愿；可作中庸不是無是非附和的反面比較，並非原文明說中庸。"
      },
      {
        "coordinate": "18.6",
        "quote": "鸟兽不可与同羣",
        "concepts": [
          "chushi",
          "yin",
          "dao"
        ],
        "reason": "隱者避世與孔子不離人群相對照，須保留不同說話人的立場。"
      },
      {
        "coordinate": "19.13",
        "quote": "学而优则仕",
        "concepts": [
          "chushi",
          "xue",
          "shi-office",
          "xueroushi"
        ],
        "reason": "子夏把仕與學互為有餘力時應做之事；據底本譯文，優不直接改寫為考試優秀。"
      },
      {
        "coordinate": "20.3",
        "quote": "不知命，无以为君子也",
        "concepts": [
          "tianming",
          "ming",
          "li",
          "zhiren",
          "junzi"
        ],
        "reason": "知命、知禮、知言分別聯到君子、立身、知人，形成互補的三項要求。"
      }
    ]
  }
}
